import React from "react";
import { inject, observer } from 'mobx-react';
import Util from "../../../utility/Util";

@inject('dashboardStore')
@observer
class LatestActivities extends React.Component {

  componentDidMount() {
    let { dashboardStore } = this.props;
    dashboardStore.loadActivities();
  }

  getText = (action) => {
    switch (action) {
      case "CONTENT_VISITED":
        return "Saw Document";
      case "CONTENT_SHARED":
        return "Shared Document";
      case "MEETING_ATTENDED":
        return "Attended Meeting";
      case "MEETING_INVITED":
        return "Invited for Meeting";
      default:
        return ""
    }
  }

  render(){
    const { dashboardStore } = this.props;
    const { activitiesCollection } = dashboardStore;
    const { activities } = activitiesCollection;
  return(
    <div>
      {
        activities && activities.length > 0 ? activities.map((act, index) => {
          return(
            <div key={index} className="d-flex align-items-center mb-2">
              <div className="mr-2" style={{height: "60px", width: "60px", borderRadius: "50%", overflow:"hidden"}}>
                <img 
                  src={act.primaryActor.imageUrl} 
                  alt="thumbnail" 
                  style={{height: "100%", width: "100%", objectFit: "contain", objectPosition: "center"}} />
              </div>
              <div>
                <span><b>{act.primaryActor.name}</b></span>&nbsp;
                <span>{this.getText(act.activityType)}</span>&nbsp;
                <span><u>{act.content.title || act.meeting.title}</u></span>
                <p style={{fontSize: "12px", marginBotom: "0px", color: "#cacaca"}}>{Util.getSocialDate(act.time)}</p>
              </div>
            </div>
          )
        }): <div>No Activities to show now</div>
      }
    </div>
  )
    }
}

export default LatestActivities;